import { createSelector } from 'reselect';
 
const selectMentors = (state: any) => state.mentors;


export const selectMentorsCurrentItem = createSelector([selectMentors], (mentors) => mentors.current);

export const selectMentorsListItems = createSelector([selectMentors], (mentors) => mentors.list);

export const selectMentorsQueryItems = createSelector([selectMentors], (mentors) => mentors.query);
export const selectMentorsItemById = (itemId: any) =>
    createSelector(selectMentorsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectMentorsCreatedItem = createSelector([selectMentors], (mentors) => mentors.create);

export const selectMentorsUpdatedItem = createSelector([selectMentors], (mentors) => mentors.update);

export const selectMentorsReadItem = createSelector([selectMentors], (mentors) => mentors.read);

export const selectMentorsDeletedItem = createSelector([selectMentors], (mentors) => mentors.delete);

export const selectMentorsSearchedItems = createSelector([selectMentors], (mentors) => mentors.search);

export const selectMentorsItemsCount = createSelector([selectMentors], (mentors) => mentors.count);

export const selectMentorsItemsFilter = createSelector([selectMentors], (mentors) => mentors.filter);